// client/src/pages/ProfilePage.jsx - Page de profil
import React, { useContext, useEffect, useState } from 'react';
//Importe PreferenceCategory
import { PreferenceCategory , IngredientsSelector, PersonCounter } from '../components/utils/PersonalizedForm';
import AuthContext from '../context/AuthContext';
import api from '../api/api';
import LocationForm from '../components/utils/LocationForm';
import Seo from '../components/Seo';

import allergiesList from "../data/allergiesList"; 
import dislikedIngredientsList from "../data/dislikedIngredientsList"; 

const ProfilePage = () => {
  const { user, updateProfile } = useContext(AuthContext);
  const [formData, setFormData] = useState({
    name: user.name || '',
    preferences: user.preferences,
    household: {
      size: user.household?.size || 1,
      includesChildren: user.household?.includesChildren || false,
    },
    location: user.location || {
      address: '',
      city: '',
      postalCode: '',
      country: 'France',
      coordinates: null
    },
  });
  
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const isPremium = ['premium','unlimited'].includes(user.subscription?.type);

  const handleUpgrade = async () => {
    try {
      const { data } = await api.post('/api/stripe/checkout-session');
      if (data?.url) window.location.href = data.url;
    } catch (e) {
      setError(e.response?.data?.message || e.message || "Erreur lors de l'abonnement");
    }
  };

  const handleManageBilling = async () => {
    try {
      const { data } = await api.post('/api/stripe/portal-session');
      if (data?.url) window.location.href = data.url;
    } catch (e) {
      setError(e.response?.data?.message || e.message || "Erreur d'ouverture du portail de facturation");
    }
  };
  
  // Gestion des changements pour les champs simples
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  useEffect(() => {
    console.log(formData)
  },[formData])


  // Fonction qui ajoute ou retire un item d'une catégorie de préférences (ex: 'allergies', 'favorites', etc.)
  const togglePreference = (category, item) => {
    setFormData(prev => {
      // Ensure preferences exists
      const currentPreferences = prev.preferences || {};
      
      // Ensure category exists
      const currentCategory = currentPreferences[category] || [];

      return {
        ...prev,
        preferences: {
          ...currentPreferences,
          [category]: currentCategory.includes(item)
            ? currentCategory.filter(i => i !== item)
            : [...currentCategory, item]
        }
      };
    });
  };
  // Gestion des changements pour les champs de préférences
  const handlePreferenceChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      preferences: {
        ...formData.preferences,
        [name]: value.split(',').map((item) => item.trim()),
      },
    });
  };

      //Gestion universelle des préf
      const handlePreferencesChange = (ingredients, type) => {
        setFormData(prev => ({
          ...prev,
          preferences: {
            ...prev.preferences,
            [type]: ingredients
          }
        }));
      };
  
  // Gestion des changements pour les objectifs nutritionnels
  const handleNutritionalGoalChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      preferences: {
        ...formData.preferences,
        nutritionalGoals: {
          ...formData.preferences.nutritionalGoals,
          [name]: value ? Number(value) : '',
        },
      },
    });
  };
  
  // Gestion des changements pour le ménage
  const handleHouseholdChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      household: {
        ...formData.household,
        [name]: type === 'checkbox' ? checked : Number(value),
      },
    });
  };

  const handleLocationUpdate = (newLocation) => {
    setFormData(prev => ({
      ...prev,
      location: newLocation
    }));
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      setLoading(true);
      setError(null);
      console.log('Form data to submit:', formData);
      await updateProfile(formData);
      
      setSuccess(true);
      
      // Masquer le message de succès après quelques secondes
      setTimeout(() => {
        setSuccess(false);
      }, 3000);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };
  
  return (  // Add return statement here
    <>
      <Seo
        title="Mon profil"
        description="Mettez à jour vos préférences culinaires et informations personnelles pour des repas encore plus personnalisés."
        breadcrumb
        noindex
      />
      <div className="max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-8 text-[#2C3E50]">Votre Profil</h1>
      
      {error && (
        <div className="bg-red-100 text-red-800 p-4 rounded-lg mb-6 border border-red-200">
          {error}
        </div>
      )}
      
      {success && (
        <div className="bg-[#87A96B]/10 text-[#87A96B] p-4 rounded-lg mb-6 border border-[#87A96B]/30">
          Profil mis à jour avec succès!
        </div>
      )}
      
      {/* Abonnement */}
      <div className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-100 mb-6">
        <div className="p-6 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <div className="text-sm text-gray-500">Abonnement</div>
            <div className="text-lg font-semibold text-[#2C3E50] capitalize">{user.subscription?.type || 'free'}</div>
            {user.subscription?.expiresAt && (
              <div className="text-sm text-gray-600">Renouvellement le {new Date(user.subscription.expiresAt).toLocaleDateString()}</div>
            )}
          </div>
          <div className="flex gap-2 flex-wrap">
            {!isPremium ? (
              <button onClick={handleUpgrade} className="px-4 py-2 bg-[#E67E22] text-white rounded-lg hover:bg-[#E67E22]/90 transition-colors font-medium">Passer Premium</button>
            ) : (
              <button onClick={handleManageBilling} className="px-4 py-2 bg-[#87A96B] text-white rounded-lg hover:bg-[#87A96B]/90 transition-colors font-medium">Gérer la facturation</button>
            )}
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-100">
        <div className="p-6">
          <h2 className="text-xl font-semibold mb-6 text-[#2C3E50]">Informations personnelles</h2>
          
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div>
                <label
                  htmlFor="name"
                  className="block text-[#2C3E50] font-medium mb-2"
                >
                  Nom
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#87A96B] focus:border-[#87A96B] transition-colors"
                  required
                />
              </div>
              
              <div>
                <label
                  htmlFor="email"
                  className="block text-[#2C3E50] font-medium mb-2"
                >
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  value={user.email}
                  className="w-full p-3 border border-gray-300 rounded-lg bg-gray-100"
                  disabled
                />
                <p className="text-sm text-gray-500 mt-1">
                  L'email ne peut pas être modifié
                </p>
              </div>
            </div>
            <div className="mb-8">
              <h3 className="text-lg font-medium mb-4 text-[#2C3E50]">📍Votre localisation (pour vous proposer des recettes de saison)</h3>
              <LocationForm 
                initialLocation={formData.location}
                onLocationUpdate={handleLocationUpdate}
              />
            </div>
            <div className="mb-8">
              <h3 className="text-lg font-medium mb-4 text-[#2C3E50]">🌱🍽️Préférences alimentaires (pour des recettes qui vous conviennent)</h3>
              
              <div className="grid grid-cols-1 md:grid-cols-1 gap-6">
                <div>
                  <PreferenceCategory
                    title="Je suis le/les régimes suivants..."
                    color="green"
                    items={[
                    { name: "Végétarien", img: "./img/vegetarian.png", icon: "" },
                    { name: "Végan", img: "./img/vegan.png", icon: "" },
                    { name: "Pescetarien", img: "./img/pescetarien.png", icon: "" },
                    { name: "Sans gluten", img: "./img/gluten-free.png", icon: "" },
                    { name: "Sans lactose", img: "./img/lactose-free.png", icon: "" },
                    { name: "Cétogène", img: "./img/cetogene.png", icon: "" },
                    { name: "Low Carb", img: "./img/low-carb.png", icon: "" },
                    { name: "Halal", img: "./img/halal.png", icon: "" },
                    ]}
                    selectedItems={formData.preferences.dietaryRestrictions}
                    onToggle={togglePreference}
                    inputName="dietaryRestrictions"
                    placeholder="Ajouter ou préciser les restrictions..."
                    cols={2}
                  />
                </div>
                
                <div>
                  <label
                    htmlFor="allergies"
                    className="block text-[#2C3E50] font-medium mb-2"
                  >
                    Allergies
                  </label>
                  <IngredientsSelector onChange={(e)=>handlePreferencesChange(e, 'allergies')} ingredientsList={allergiesList} initialSelected={formData.preferences.allergies}/>
                </div>
                
                <div>
                  <label
                    htmlFor="dislikedIngredients"
                    className="block text-[#2C3E50] font-medium mb-2"
                  >
                    Ingrédients non aimés
                  </label>
                  <IngredientsSelector onChange={(e)=>handlePreferencesChange(e, 'dislikedIngredients')} ingredientsList={dislikedIngredientsList} initialSelected={formData.preferences.dislikedIngredients}/>
                </div>
              </div>
            </div>
            
            <div className="mb-8">
              <h3 className="text-lg font-medium mb-4 text-[#2C3E50]">🎯Objectifs (pour vous aider à les atteindre)</h3>
              <h4 className="text-lg font-medium mb-4 text-[#2C3E50]">Objectifs personnels</h4>
              <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
                <div>
                  <PreferenceCategory
                        title="L'application doit m'aider à..."
                        color="green"
                        items={[
                        { name: "Perte de poids", img: "./img/lose-weight.png", icon: "" },
                        { name: "Booster ses performances", img: "./img/performance.png", icon: "" },
                        { name: "Diminuer le stress pour élaborer les repas", img: "./img/zen.png", icon: "" },
                        { name: "Mieux planifier ma semaine", img: "./img/planify.png", icon: "" },
                        { name: "Faire des économies", img: "./img/economy.png", icon: "" },
                        { name: "Découvrir des plats adaptés à mes goûts", img: "./img/taste.png", icon: "" },
                        { name: "Privilégier une alimentation saine", img: "./img/healthy.png", icon: "" },
                        { name: "Adapter mes repas à un régime alimentaire/carences", img: "./img/regime.png", icon: "" },
                        ]}
                        selectedItems={formData.preferences.goals}
                        onToggle={togglePreference}
                        inputName="goals"
                        placeholder="Préciser ou ajouter des régimes alimentaires..."
                        cols={2}
                    />
                </div>
              </div>              
              <h4 className="text-lg font-medium mb-4 text-[#2C3E50]">Objectifs nutritionnels</h4>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                <div>
                  <label
                    htmlFor="calories"
                    className="block text-[#2C3E50] font-medium mb-2"
                  >
                    Calories
                  </label>
                  <input
                    type="number"
                    id="calories"
                    name="calories"
                    value={formData.preferences.nutritionalGoals.calories}
                    onChange={handleNutritionalGoalChange}
                    placeholder="2000"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#87A96B] focus:border-[#87A96B] transition-colors"
                    min="0"
                  />
                </div>
                
                <div>
                  <label
                    htmlFor="protein"
                    className="block text-[#2C3E50] font-medium mb-2"
                  >
                    Protéines (g)
                  </label>
                  <input
                    type="number"
                    id="protein"
                    name="protein"
                    value={formData.preferences.nutritionalGoals.protein}
                    onChange={handleNutritionalGoalChange}
                    placeholder="100"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#87A96B] focus:border-[#87A96B] transition-colors"
                    min="0"
                  />
                </div>
                
                <div>
                  <label
                    htmlFor="carbs"
                    className="block text-[#2C3E50] font-medium mb-2"
                  >
                    Glucides (g)
                  </label>
                  <input
                    type="number"
                    id="carbs"
                    name="carbs"
                    value={formData.preferences.nutritionalGoals.carbs}
                    onChange={handleNutritionalGoalChange}
                    placeholder="250"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#87A96B] focus:border-[#87A96B] transition-colors"
                    min="0"
                  />
                </div>
                
                <div>
                  <label
                    htmlFor="fat"
                    className="block text-[#2C3E50] font-medium mb-2"
                  >
                    Lipides (g)
                  </label>
                  <input
                    type="number"
                    id="fat"
                    name="fat"
                    value={formData.preferences.nutritionalGoals.fat}
                    onChange={handleNutritionalGoalChange}
                    placeholder="70"
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#87A96B] focus:border-[#87A96B] transition-colors"
                    min="0"
                  />
                </div>
              </div>
            </div>
            
            <div className="mb-8">
              <h3 className="text-lg font-medium mb-4 text-[#2C3E50]">🏠Votre foyer (pour vous donner les bonnes quantités)</h3>
              <h4 className="text-lg font-medium mb-4 text-[#2C3E50]">Composition du foyer</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <PersonCounter 
                label="Adultes"
                count={formData.preferences.adultCount||0}
                onIncrement={() => setFormData({
                  ...formData, 
                  preferences: {
                    ...formData.preferences,
                    adultCount: (formData.preferences.adultCount||0) + 1
                  }
                })}
                onDecrement={() => setFormData({
                  ...formData,
                  preferences: {
                    ...formData.preferences,
                    adultCount: Math.max(0, (formData.preferences.adultCount||0) - 1)
                  }
                })}
                imageUrl="./img/adult.png"
              />
              
              <PersonCounter 
                label="Enfants"
                count={formData.preferences.childrenCount||0}
                onIncrement={() => setFormData({
                  ...formData,
                  preferences: {
                    ...formData.preferences,
                    childrenCount: (formData.preferences.childrenCount||0) + 1
                  }
                })}
                onDecrement={() => setFormData({
                  ...formData,
                  preferences: {
                    ...formData.preferences,
                    childrenCount: Math.max(0, (formData.preferences.childrenCount||0) - 1)
                  }
                })}
                imageUrl="./img/children.png"
              />
              </div>
            </div>
            <div className="mb-8">
              <h3 className="text-lg font-medium mb-4 text-[#2C3E50]">🍳Votre matériel de cuisine (pour vous faire gagner du temps)</h3>
              <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
                <div>
                  <PreferenceCategory
                        title="Cuisson & préparation chaude"
                        color="green"
                        items={[
                        { name: "Four traditionnel", img: "./img/oven.png", icon: "" },
                        { name: "Four à chaleur tournante", img: "./img/turning-oven.png", icon: "" },
                        { name: "Four vapeur", img: "./img/vapor-oven.png", icon: "" },
                        { name: "Plaques de cuisson", img: "./img/cooking-plate.png", icon: "" },
                        { name: "Micro-ondes", img: "./img/micro-wave.png", icon: "" },
                        { name: "Friteuse classique", img: "./img/fryer.png", icon: "" },
                        { name: "Friteuse à air (Airfryer)", img: "./img/air-fryer.png", icon: "" },
                        { name: "Grille-pain", img: "./img/toaster.png", icon: "" },
                        { name: "Gaufrier / appareil à croque-monsieur", img: "./img/croque-monsieur.png", icon: "" },
                        { name: "Plancha", img: "./img/plancha.png", icon: "" },
                        { name: "Barbecue", img: "./img/barbecue.png", icon: "" },
                        { name: "Cuiseur vapeur", img: "./img/steamer.png", icon: "" },
                        { name: "Wok électrique", img: "./img/wok.png", icon: "" },
                        { name: "Crêpière", img: "./img/crepe.png", icon: "" },
                        { name: "Appareil à fondue", img: "./img/fondue.png", icon: "" },
                        { name: "Appareil à raclette", img: "./img/raclette.png", icon: "" }
                        ]}
                        selectedItems={formData.preferences.cookingEquipment}
                        onToggle={togglePreference}
                        inputName="cookingEquipment"
                        placeholder="Préciser ou ajouter du matériel..."
                        cols={2}
                    />
                    <PreferenceCategory
                      title="Multifonctions / Robots"
                      color="green"
                      items={[
                        { name: "Thermomix (TM5 / TM6)", img: "./img/thermomix.png", icon: "" },
                        { name: "Monsieur Cuisine (Connect / Smart)", img: "./img/mr-cuisine.png", icon: "" },
                        { name: "Cookeo", img: "./img/cookeo.png", icon: "" },
                        { name: "i-Companion", img: "./img/i-companion.png", icon: "" },
                        { name: "Magimix Cook Expert", img: "./img/cook-expert.png", icon: "" },
                        { name: "Ninja Foodi", img: "./img/ninja-foodi.png", icon: "" },
                        { name: "Robot cuiseur multifonction (générique)", img: "./img/generic-robot.png", icon: "" },
                        { name: "Multicuiseur", img: "./img/multicooker.png", icon: "" },
                      ]}
                      selectedItems={formData.preferences.multifunctionRobot}
                      onToggle={togglePreference}
                      inputName="multifunctionRobot"
                      placeholder="Préciser ou ajouter du matériel..."
                      cols={2}
                    />
                    <PreferenceCategory
                      title="Mixage, découpe, transformation"
                      color="green"
                      items={[
                        { name: "Blender", img: "./img/blender.png", icon: "" },
                        { name: "Mixeur plongeant", img: "./img/mixer.png", icon: "" },
                        { name: "Robot multifonction", img: "./img/multi-robot.png", icon: "" },
                        { name: "Hachoir électrique", img: "./img/chopper.png", icon: "" },
                        { name: "Batteur électrique / robot pâtissier", img: "./img/electric-mixer.png", icon: "" },
                        { name: "Râpe ou spiralizer électrique", img: "./img/spiralizer.png", icon: "" },
                        { name: "Extracteur de jus", img: "./img/juice-extractor.png", icon: "" },
                        { name: "Centrifugeuse", img: "./img/centrifuge.png", icon: "" },
                      ]}
                      selectedItems={formData.preferences.blendingEquipment}
                      onToggle={togglePreference}
                      inputName="blendingEquipment"
                      placeholder="Préciser ou ajouter du matériel..."
                      cols={2}
                    />
                    <PreferenceCategory
                      title="Froid / conservation"
                      color="green"
                      items={[
                        { name: "Réfrigérateur", img: "./img/fridge.png", icon: "" },
                        { name: "Congélateur", img: "./img/freezer.png", icon: "" },
                        { name: "Sorbetière / turbine à glace", img: "./img/ice-cream-maker.png", icon: "" },
                        { name: "Machine sous vide", img: "./img/vacuum-machine.png", icon: "" },
                      ]}
                      selectedItems={formData.preferences.coldStorageEquipment}
                      onToggle={togglePreference}
                      inputName="coldStorageEquipment"
                      placeholder="Préciser ou ajouter du matériel..."
                      cols={2}
                    />
                    <PreferenceCategory
                      title="Boulangerie / spécialités"
                      color="green"
                      items={[
                        { name: "Machine à pain", img: "./img/bread-maker.png", icon: "" },
                        { name: "Machine à pâtes fraîches", img: "./img/pasta-maker.png", icon: "" },
                        { name: "Fermentateur / yaourtière", img: "./img/yaourt-maker.png", icon: "" },
                        { name: "Fumoir", img: "./img/smoker.png", icon: "" },
                      ]}
                      selectedItems={formData.preferences.bakingEquipment}
                      onToggle={togglePreference}
                      inputName="bakingEquipment"
                      placeholder="Préciser ou ajouter du matériel..."
                      cols={2}
                    />
                </div>
              </div> 
            </div>

            <div className="flex justify-end">
              <button
                type="submit"
                className="px-6 py-3 bg-[#87A96B] text-white rounded-lg font-medium hover:bg-[#87A96B]/90 disabled:bg-gray-400 transition-colors shadow-md"
                disabled={loading}
              >
                {loading ? 'Enregistrement...' : 'Enregistrer les modifications'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    </>
  );
};

export default ProfilePage;
